import { Component } from 'react';
import { UserContext } from 'contexts/User';
import { getDisplayName } from 'utils/component';

export default function withUser(WrappedComponent) {
    class WithUser extends Component {
        render() {
            const { user } = this.context;

            return <WrappedComponent user={user} {...this.props} />;
        }
    }

    WithUser.displayName = `WithUser(${getDisplayName(WrappedComponent)})`;
    WithUser.contextType = UserContext;

    return WithUser;
}
